import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { FormLabel, Typography } from '@mui/material';

export interface ITableLayout {
  label?: string;
  value: any;
}

export const TableLayout = ({ label, value }) => {
  const classes = useStyles();
  return (
    <div className={classes.panelSummaryWrapper}>
      {label && (
        <FormLabel component="span" className={classes.labelName}>
          {label}
        </FormLabel>
      )}
      <Typography component="span">{value ?? '--'}</Typography>
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  panelSummaryWrapper: {
    marginBottom: '0.5rem',
    '&:first-child': { marginTop: 0 }
  },
  labelName: {
    color: theme.palette.primary.main,
    fontWeight: 600,
    marginRight: 10
  }
}));
